import sliceCreator from '../../index.jsx';
import {GET_ALL_POST_MONTHLY_TARGETS} from '../../../constants/index.jsx';
const _getAllPostMonthlyTargetsAction = sliceCreator('GET_ALL_POST_MONTHLY_TARGETS', GET_ALL_POST_MONTHLY_TARGETS, 'get');

const { asyncAction: getAllPostMonthlyTargetsAction, reducer, clearData: clearGetAllPostMonthlyTargetsAction } = _getAllPostMonthlyTargetsAction;

export default reducer;

export {
    getAllPostMonthlyTargetsAction,
    clearGetAllPostMonthlyTargetsAction
}
